import { Hourglass } from "@phosphor-icons/react";
import { PRICING } from "@/data/categories";

export const PremiumStrip = ({ onOpen }) => (
  <section data-testid="premium-strip" className="rounded-2xl border border-[#C99A5B]/25 bg-[#FBF4E8] p-5 sm:p-6">
    <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#A84A32]">Optional creations</p>
    <h2 className="mt-1 font-serif text-2xl text-[#2C2A28] sm:text-3xl">Turn your memories into something more</h2>
    <p data-testid="premium-gst-note" className="mt-1 text-xs text-[#8A7F76]">All prices in AUD · No GST applies</p>
    <div className="-mx-5 mt-5 flex snap-x snap-mandatory scroll-px-5 gap-3 overflow-x-auto px-5 pb-2 sm:mx-0 sm:grid sm:grid-cols-2 sm:gap-4 sm:overflow-visible sm:px-0 sm:pb-0 xl:grid-cols-4">
      {PRICING.ai.map((a) => (
        <button
          key={a.id}
          type="button"
          data-testid={`premium-card-${a.id}`}
          onClick={onOpen}
          className="flex w-[78%] shrink-0 snap-start flex-col rounded-xl border border-[#2C2A28]/10 bg-white p-4 text-left transition-[box-shadow,transform] hover:-translate-y-0.5 hover:shadow-md sm:w-auto"
        >
          <span className="flex items-baseline justify-between gap-3">
            <span className="font-serif text-lg leading-snug text-[#2C2A28]">{a.label}</span>
            <span data-testid={`premium-price-${a.id}`} className="shrink-0 font-semibold text-[#A84A32]">
              {PRICING.currency}{a.price.toFixed(2)}
            </span>
          </span>
          <span className="mt-2 text-sm leading-relaxed text-[#6B635B]">{a.desc}</span>
        </button>
      ))}
    </div>
    <p data-testid="premium-legacy" className="mt-4 flex items-start gap-2 text-sm leading-relaxed text-[#6B635B]">
      <Hourglass size={16} weight="duotone" className="mt-0.5 shrink-0 text-[#C99A5B]" />
      <span><strong className="font-semibold text-[#2C2A28]">Coming later: {PRICING.legacy.label}</strong> — {PRICING.legacy.desc}</span>
    </p>
  </section>
);
